<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view  v-if="isRouterAlive" />
    </div>
  </a-config-provider>
</template>

<script>
export default {
  name: 'App',
  //提供页面reload方法
  provide() {
    return {
      reload: this.reload
    };
  },
  data () {
    return {
      locale: this.$zhCN,  //设置全局中文化,
      isRouterAlive: true //刷新页面用
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  },
  created(){
  }
}
</script>
<style>
#app {
  font-family: '微软雅黑', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #444;;
  height: 100%;
  min-height: 450px;
  background-color: #ccc;
}
/* 公共样式 */
/*button*/
.ant-btn{
  padding: 0 10px;
  border: 1px solid #006699; 
  box-shadow: 1px 1px 3px #233447;
  color: #233447;
  font-size: 12px;
}
.ant-btn i{
  font-size: 13px;
  margin-left: 4px!important;
  margin-right: 4px;
}
.ant-btn:hover,
.ant-btn:focus{
  color: #006699;
  box-shadow: 1px 1px 3px #233447 inset;
  border-color: #006699;
}
.ant-btn-primary{
  background-color: #006699;
  color: white;
}
.ant-btn-primary:hover,
.ant-btn-primary:focus{
  color: #fff;
  background-color: #006699;
  box-shadow: 1px 1px 3px #233447 inset;
}
/*select*/
.ant-select-selection{
  border: 1px solid #006699;
}
.ant-select-open .ant-select-selectio,
.ant-select-focused .ant-select-selection,
.ant-select-selection:focus,
.ant-select-selection:active,
.ant-select-selection:hover{
  border-color: #006699;
  box-shadow: 0 0 0 2px #00669961;
}
.ant-select-dropdown-menu-item:hover,
.ant-select-dropdown-menu-item-selected,
.ant-select-dropdown-menu-item-selected:hover,
.ant-select-dropdown-menu-item-active {
  background-color: #00669961;
}
/*input*/
.ant-input,
.ant-input-number{
  border: 1px solid #006699;
}
.ant-input:focus,
.ant-input:active,
.ant-input:hover{
  border: 1px solid #006699!important;
  box-shadow: 0 0 0 2px #00669961;
}
.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
    border-color: #006699;
}
input:-internal-autofill-selected {
    background-color: #ccc !important;
}
/*radio*/
.ant-radio-checked .ant-radio-inner,
.ant-radio-wrapper:hover .ant-radio,
.ant-radio:hover .ant-radio-inner,
.ant-radio-input:focus + .ant-radio-inner {
  border-color: #006699;
}
.ant-radio-inner::after{
  background-color: #006699;
}
.ant-radio-checked::after{
  border: 1px solid #006699;
}
.ant-radio-input:focus + .ant-radio-inner{
  box-shadow: 0 0 0 3px #00669961
}
/*checkbox*/
.ant-checkbox-checked .ant-checkbox-inner {
    background-color: #006699;
    border-color: #006699;
}
.ant-checkbox-wrapper:hover .ant-checkbox-inner,
.ant-checkbox:hover .ant-checkbox-inner,
.ant-checkbox-input:focus + .ant-checkbox-inner{
  border-color: #006699;
}
/*calendar*/
.ant-calendar-date:hover {
    background: #00669961;
}
.ant-calendar-today .ant-calendar-date {
    color: #006699;
    border-color: #006699;
    background-color: white;
}
.ant-calendar-range .ant-calendar-in-range-cell::before {
    background: #00669961;
}
.ant-calendar-selected-date .ant-calendar-date, 
.ant-calendar-selected-start-date .ant-calendar-date, 
.ant-calendar-selected-end-date .ant-calendar-date {
    background: #006699;
    color:white;
}
.ant-calendar-selected-date .ant-calendar-date:hover, 
.ant-calendar-selected-start-date .ant-calendar-date:hover, 
.ant-calendar-selected-end-date .ant-calendar-date:hover {
    background: #006699;
    color:white;
}
.ant-calendar-picker:focus .ant-calendar-picker-input:not(.ant-input-disabled){
  border: 1px solid #006699;
  box-shadow: 0 0 0 2px #00669961;
}
.ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled){
  border: 1px solid #006699;
}
/*message*/
.ant-message-notice-content {
  box-shadow: 0 0px 7px rgb(150, 14, 14);
}
/*a标签*/
a:hover{
  text-decoration: none;
}
table a {
  color: #006699!important;
}
table a:hover{
  color: #006DA2;
  font-weight: 700;
}
table a i{
  font-size: 18px!important;
}
/* table */
.ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding: 8px 16px;
}
/* 火狐样式bug调整 */
.ant-table-thead > tr > th.ant-table-column-has-actions {
    -webkit-background-clip: padding-box;
}
/*i标签*/
.anticon{
  vertical-align: 0;
}
/*tree*/
.ant-tree.ant-tree-show-line li span.ant-tree-switcher {
    color: #933;
    background: #f0f2f5;
}
/*滚动条*/
::-webkit-scrollbar{
  width:1px;
  height: 8px;
  background-color:#dedbde;
}
::-webkit-scrollbar-thumb{
  background-color: rgb(143, 141, 141);
  border-radius: 4px;
}
/* form标题 */
.tagTip{
  display: block;
  text-align: left;
    padding: 10px 30px;
    font-size: 18px;
    color: #233447;
}
.tagTip i{
  color: #006699;
}

/*分隔符*/
.ant-divider-horizontal {
    margin: 20px 0;
    background: #006699;
}

/*tab标签页*/
.ant-tabs-nav .ant-tabs-tab-active {
    color: #006699;
}
.ant-tabs-nav .ant-tabs-tab:hover {
  color: #006699;
}
.ant-tabs-nav .ant-tabs-tab:active {
  color: #006699;
}
.ant-tabs-ink-bar {
    background-color: #006699;
    height: 4px;
}


/* 图标 */
.fa-check-circle-o{
  color: #10b307;
  font-size: 20px;
}
.fa-hourglass-half{
  color: #e49418;
  font-size: 15px;
}
.fa-circle-o{
  color: #0b9ce4;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue